<template>
  <div class="header">
    <div class="logo-box" >
      <div class="system-logo cp" @click="toIndex()">
        <img src="../../../static/image/logo.png" />
      </div>
    </div>
    <div class="menu-box">
<!--      <div class="menu-item" @click="menuItemFn(i)" :class="{active:i===index}" v-for="(item,i) in menuData">
        {{item.name}}
      </div>-->
    </div>
    <div class="user-box">
      <module ref="module"></module>
    </div>
  </div>

</template>

<script>
  import Module from "./module";

  export default {
    name: "QC_Header",
    components: {Module},
    computed: {
      menuData:function(){
        return this.$store.state.user.menuList;
      },
      index:function(){
        return this.$store.state.index;
      },
    },
    watch:{
      $route(val){
        if(!val.meta.IgnoreAuth){
          this.$store.state.user.menuList.forEach((row,index)=>{
            row.children&&row.children.forEach(item=>{
              if(val.path===(item.url)){
                localStorage.setItem('index',index);
                this.$store.commit("addIndex",index);
              }
            })
          })
        }
      }
    },
    data() {
      return {
        source: source
      }
    },
    mixins: [tableBase],
    methods: {
      initDict() {
        this.simplePost(Api.open + "dict/getAll", null, result => {
          this.$store.commit("addDict", result.data.dictMap);
          this.$store.commit("addRegion", result.data.regionMap);
        });
      },
      menuItemFn(index){
        const item = this.menuData[index];
        localStorage.setItem('index',index);
        this.$store.commit("addIndex",index);
        if(item.children&&item.children.length>0){
          if(item.children[0].url){
            this.$router.push({path:item.children[0].url});
          }else{
            this.$router.push({path:item.children[0].children[0].url});
          }
        }else{
          this.$router.push({path:item.url});
        }
      },
      toIndex(){
        this.toRouter('/index/hospital/list');
      }
    },
    mounted() {
      this.initDict();//初始化字典
    },
    created() {
    }
  }
</script>


<style lang="less" scoped>
  .header{
    display: flex;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(22,50,138,0.28);
    height: 60px;
    .logo-box{
      border-bottom: 1px solid #e6e6e6;
      margin-left: 10px;
      .system-logo {
        color: #000000;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        img {
          height: 190px;
        }
      }
    }
    .menu-box{
      flex: 1;
      display: flex;
      align-items: flex-end;
      border-bottom: 1px solid #e6e6e6;
      .menu-item{
        width: 120px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background: #F5F3F2;
        border-radius: 10px 10px 0px 0px;
        &.active{
          background: #E0F1FF;
          color: #0070FF;
        }
        &+.menu-item{
          margin-left: 10px;
        }
      }
    }
    .user-box{
      border-bottom: 1px solid #e6e6e6;
    }
  }
</style>
